<form class="reply-form ">
  <div class="commentBox">
    <ul class="list-unstyled">
      <li *ngFor="let comment of comentarios">
        <span class="profileBox" [matTooltip]="comment?.pessoa?.nome">{{comment?.pessoa?.nome | slice:0:1
          }}</span>
        <span class="profileText">
          <p style="margin: 0 0 5px;">{{comment.comentario}}</p>
          <span class="pull-right" style="font-size: 12px;">
            {{comment?.pessoa?.nome | titlecase }} -
            {{comment?.hora}} |
            {{comment?.data | date: "dd/MM/yyyy"}}</span>
        </span>
      </li>
    </ul>
  </div>
  <div id="div_id_username" class="form-group required">
    <div class="controls form-group d-flex w-100 ">
      <input class="input-md  textinput textInput form-control" id="id_username" placeholder="Adicione um comentário"
        type="text" #comentar />
      <button type="button" class="btn btn-primary border-radius-0  m-0 w-25" (click)="comentarmedicao(comentar.value)"
        [disabled]="!comentar.value">COMENTAR</button>
    </div>
  </div>
</form>
<div *ngIf="usuario?.user?.pessoa?.cliente">
  <div class="btn-group" role="group" aria-label="..." *ngIf="!medicao?.status">
    <button class="btn btn-madelife btn-success" (click)="aprovarMedicao(medicao)">APROVAR</button>
    <button class="btn btn-madelife btn-danger" (click)="reprovaMedicao()">REPROVAR</button>
  </div>
</div>
